import gql from 'graphql-tag';

export const UPSERT_CAR = gql`
  mutation($data: CarInput!) {
    upsertCar(data: $data)
  }
`;

export const makersPages = {
  トヨタ: 'https://www.toyota.co.jp/grade/dc/top',
  日産: 'https://grade-search.nissan.co.jp/GRADE/search.html',
  ホンダ: 'http://grade.customer.honda.co.jp/apps/grade/hccg0010101.do',
  ダイハツ: 'http://inquiry.daihatsu.co.jp/gradeweb/default.aspx',
  スバル: 'http://grade-search.subaru.jp/luw/',
  三菱: 'https://inquiry.mitsubishi-motors.co.jp/reference/GradeSearch.do',
  スズキ: 'http://grade-search.suzuki.co.jp/SGRE/page/gradeSearch.html',
  マツダ: 'https://support.mazda.co.jp/grade-search/',
};

export const fieldsLabels = {
  TransmissionId: 'ミッション',
  Grade: 'クレード・パッケージ',
  EqStereo: 'ステレオ',
  EqAluminiumWheel: 'AW',
  EqCruiseControl: 'クルーズコントロール',
  EqGenuineLeather: '本革',
  EqNavigation: 'ナビ',
  DrivingType: '駆動記号',
  CountDoors: 'ドア',
  CountHumans: '乗車定員',
  StartSale: '販売開始',
  EndSale: '販売終了',
  EqRearUnderSpoiler: 'リアアンダースポイラー',
  EqDischargeHeadLamp: 'ディスチャージヘッドランプ',
  EqBackEyes: 'バックアイ',
  engine: '総排気量',
  Drive: '駆動',
  EqPowerSteering: 'PS',
  CertifiedModel: '型式',
  EqAircondition: 'AC',
  EqAbs: 'ABS',
  EqAirbag: 'SRS',
  EqSr: 'サンルーフ',
  EqFullAero: 'フルエアロ',
  SelfEmissionMeter: 'メーターパネル輝度調節機能',
  FuelId: '燃料の種類',
  EqDynamicControl: 'ビークルダイナミックコントロール',
  EqTractionControl: 'トラクションコントロール',
  EqKeylessEntry: 'キーレスエントリー',
  EqIntelligentKey: 'インテリジェントキー',
  EqGenuineLeatherSteering: '本革巻きステアリング',
  RoofType: 'ルーフ形状',
  EqWoodPanel: 'ウッドパネル',
  EqHighMountStopLamp: 'ハイマウントストップランプ',
  EqCornerBackSonar: 'コーナーバックソナー',
  EqElectricDoorMirror: '電動ドアミラー',
  EqPowerWindow: 'PW',
  EqFogLamp: 'フォッグランプ',
  EqCentralizedDoorLock: '集中ドアロック',
  EqRearSpoiler: 'リアスポイラー',
  EqLowdown: 'ローダウン',
  EqSideBlindMonitor: 'サイドブラインドモニター',
  EqFrontSpoiler: 'フロントスポイラー',
  HeaterSheet: 'シートヒーター',
  EqPowerSeats: 'パーワーシート',
  GenuineLeatherWrappedSteering: 'レザーステアリング',
};

export default gql`
  query ($qr: String!) {
    gradesByQR(
      qr: $qr
    ) {
      params {
        ModelNumber
        ClassificationNumber
        Year
        Katashiki
        ShakenFinishDate
        VIN
        EngineModel
      }
      error
      data {
        HoyuID
        VehicleID
        BrandNameEn
        BrandNameJp
        ModelNameEn
        ModelNameJp
        Grade
        CertifiedModel
        CertifiedModelWithoutEmissionLevel
        KnownType
        PassengerClassification
        Drive
        DrivingType
        CountDoors
        CountHumans
        FuelId
        StartSale
        EndSale
        engine
        TransmissionId
        Cooler
        CoolerExisiting
        AirConditioner
        AirConditionerExisting
        FullAutoAirConditioner
        FullAutoAirConditionerExisting
        DualAirConditioner
        DualAirConditionerExisting
        CleanFiler
        CleanFilerExisting
        PureTron
        PureTronExisting
        RoofType
        RearHeater
        RearHeaterExisting
        MildFlowSystem
        MildFlowSystemExisting
        Cassette
        CassetteExisting
        Md
        MdExisting
        Tv
        TvExisting
        NavigationSystem
        NavigationSystemExisting
        Speaker
        SpeakerExisting
        Antenna
        AntennaExisting
        Etc
        EtcExisting
        ExternalConnectionTerminal
        ExternalConnectionTerminalExisting
        MusicRecordingReproduction
        MusicRecordingReproductionExisting
        HandsfreePhone
        HandsfreePhoneExisting
        CdDvdVideoPlayback
        CdDvdVideoPlaybackExisting
        RearSeatMonitor
        RearSeatMonitorExisting
        GenuineLeatherWrappedSteering
        GenuineLeatherWrappedSteeringExisting
        SteeringSwitch
        SteeringSwitchExisting
        PowerSteering
        PowerSteeringExisting
        CentralizedDoorLock
        CentralizedDoorLockExisting
        IntelligentKey
        IntelligentKeyExisting
        RemoteControlEntrySystem
        RemoteControlEntrySystemExisting
        EngineImmobilizer
        EngineImmobilizerExisting
        AutomaticInterVehicleControlSystem
        AutomaticInterVehicleControlSystemExisting
        AutoSpeedControlDevice
        AutoSpeedControlDeviceExisting
        Tachometer
        TachometerExisting
        SelfEmissionMeter
        SelfEmissionMeterExitsing
        PowerWindow
        PowerWindowExisting
        PushEngineStart
        PushEngineStartExisting
        MeterInformationDisplay
        MeterInformationDisplayExisting
        SteeringPositionAdjustment
        SteeringPositionAdjustmentExisting
        InteriorPanel
        InteriorPanelExisting
        RoofRail
        RoofRailExisting
        AutoSlidingDoor
        AutoSlidingDoorExisting
        FrontProtector
        FrontProtectorExisting
        RearProtector
        RearProtectorExisting
        SideSillProtector
        SideSillProtectorExisting
        RearGlassOpeningMechanism
        RearGlassOpeningMechanismExisting
        AutoClosure
        AutoClosureExisting
        PowerBackDoor
        PowerBackDoorExisting
        ScratchShield
        ScratchShieldExisting
        QuickChargeFunction
        QuickChargeFunctionExisting
        GlassRoof
        GlassRoofExisting
        SeatArea
        SeatAreaExisting
        DriverSeatOrFrontPassengerSeat
        DriverSeatOrFrontPassengerSeatExisting
        SecondPowerSeat
        SecondPowerSeatExisting
        SheetLifter
        SheetLifterExisting
        FrontArmRest
        FrontArmRestExisting
        RearOrSecondArmRest
        RearOrSecondArmRestExisting
        RearOrSecondSeatReclining
        RearOrSecondSeatRecliningExisting
        RearOrSecondSeatSlide
        RearOrSecondSeatSlideExisting
        RearOrSecondSeatMechanism
        RearOrSecondSeatMechanismExisting
        RearOrSecondSeatForm
        RearOrSecondSeatFormExisting
        RearOrSecondFoldableSeat
        RearOrSecondFoldableSeatExisting
        ThirdArmRest
        ThirdArmRestExisting
        ThirdSeatSlides
        ThirdSeatSlidesExisting
        ThirdSeatReclining
        ThirdSeatRecliningExisting
        ThirdSheetMechanism
        ThirdSheetMechanismExisting
        ThirdSheetForm
        ThirdSheetFormExisting
        ThirdPowerSeat
        ThirdPowerSeatExisting
        ThirdFoldableSheet
        ThirdFoldableSheetxisting
        SeatArrangement
        SeatArrangementExisting
        SheetTray
        SheetTrayExisting
        Ottoman
        OttomanExisting
        AutoDrivingPositionMemory
        AutoDrivingPositionMemoryExisting
        InsideCarPowerSupply
        InsideCarPowerSupplyExisting
        SeatBackPocket
        SeatBackPocketExisting
        HeaterSheet
        HeaterSheetExisting
        AirConditionSheet
        AirConditionSheetExisting
        StorageUnderTheFloor
        StorageUnderTheFloorExisting
        ElectricSunshade
        ElectricSunshadeExisting
        Abs
        AbsExisting
        BrakeAssistance
        BrakeAssistanceExisting
        TractionControlSystem
        TractionControlSystemExisting
        DynamicsControlSystem
        DynamicsControlSystemExisting
        AnchorForChildSeat
        AnchorForChildSeatExisting
        HighMountStopLamp
        HighMountStopLampExisting
        PowerWindowsWithEntrapmentPreventionFunction
        PowerWindowsWithEntrapmentPreventionFunctionExisting
        CollisionSafetyBody
        CollisionSafetyBodyExisting
        PreCrashBrakeAssist
        PreCrashBrakeAssistExisting
        AntiTheftAlarm
        AntiTheftAlarmExisting
        ActiveHeadRest
        ActiveHeadRestExisting
        FrontStabilizer
        FrontStabilizerExisting
        RearStabilizer
        RearStabilizerExisting
        HillStartAssist
        HillStartAssistExisting
        CornerSensorAndBackSonar
        CornerSensorAndBackSonarExisting
        IntelligentParkingAssist
        IntelligentParkingAssistExisting
        LaneKeeperSupport
        LaneKeeperSupportExisting
        BackSideCrashAvoidanceSupportSystem
        BackSideCrashAvoidanceSupportSystemExisting
        FrontCollisionAvoidanceSupportSystem
        FrontCollisionAvoidanceSupportSystemExisting
        LabelDetectionFunction
        LabelDetectionFunctionExisting
        AssistanceForPreventionOfMisdirectedMoment
        AssistanceForPreventionOfMisdirectedMomentExisting
        AirbagSystem
        AirbagSystemExisting
        SideAirbagSystem
        SideAirbagSystemExisting
        SeatBelt
        SeatBeltExisting
        FourWheelActiveSteer
        FourWheelActiveSteerExisting
        StrengtheningBrake
        StrengtheningBrakeExisting
        StrengthenedSuspension
        StrengthenedSuspensionExisting
        AluminumRoadWheel
        AluminumRoadWheelExisting
        SpareTire
        SpareTireExisting
        RunFlatTire
        RunFlatTireExisting
        XenonHeadlamp
        XenonHeadlampExisting
        ProjectorHeadLamp
        ProjectorHeadLampExisting
        FogLampFront
        FogLampFrontExisting
        FogLampRear
        FogLampRearExisting
        BackViewMonitor
        BackViewMonitorExisting
        AdaptiveFrontLightingSystem
        AdaptiveFrontLightingSystemExisting
        AutoLightSystem
        AutoLightSystemExisting
        HeaterMirror
        HeaterMirrorExisting
        ReverseElectricMirror
        ReverseElectricMirrorExisting
        CorneringLamp
        CorneringLampExisting
        SideBlindMonitor
        SideBlindMonitorExisting
        RearWiper
        RearWiperExisting
        LedHeadlamp
        LedHeadlampExisting
        AutomaticAntiGlareRoomMirror
        AutomaticAntiGlareRoomMirrorExisting
        ElectricDoorMirror
        ElectricDoorMirrorExisting
        UvCutGlass
        UvCutGlassExisting
        PrivacyGlass
        PrivacyGlassExisting
        EqAircondition
        EqPowerSteering
        EqPowerWindow
        EqStereo
        EqAluminiumWheel
        EqPowerSeats
        EqAirbag
        EqAbs
        EqSr
        EqTv
        EqGenuineLeather
        EqNavigation
        EqAirclean
        EqFullAero
        EqLowdown
        EqFrontSpoiler
        EqRearSpoiler
        EqRearUnderSpoiler
        EqSideStep
        EqTractionControl
        EqDynamicControl
        EqActiveDumperSuspension
        EqAutoSpeedControlDevice
        EqAutoslidingDoor
        EqFogLamp
        EqCentralizedDoorLock
        EqKeylessEntry
        EqIntelligentKey
        EqGenuineLeatherSteering
        EqWoodPanel
        EqCruiseControl
        EqRoofRail
        EqHighMountStopLamp
        EqDischargeHeadLamp
        EqSideBlindMonitor
        EqTachometer
        EqEtc
        EqImmobilizer
        EqAntiTheftDevice
        EqBackEyes
        EqCornerBackSonar
        EqElectricDoorMirror
        EqLsd
        EqTurbo
      }
    }
  }`;




// WEBPACK FOOTER //
// ./src/components/catalog-consts.js